import './assets/main.css'
// FontAwesome CSS is now loaded conditionally in components that need it
// Mapbox CSS is now loaded conditionally in map components

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import * as Sentry from '@sentry/vue'
import App from './App.vue'
import router from './router'
import { sentryConfig, validateSentryConfig } from './config/sentry'

// Create Vue app instance
const app = createApp(App)

// Create Pinia store
const pinia = createPinia()

// Initialize Sentry if configuration is valid
if (validateSentryConfig()) {
  Sentry.init({
    app,
    ...sentryConfig,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      })
    ]
  })
  
  // Make Sentry available globally for helper functions
  if (typeof window !== 'undefined') {
    window.Sentry = Sentry
  }
}

// Register Pinia and router
app.use(pinia)
app.use(router)

// Initialize auth state on app startup
import { useAuthStore } from '@/stores/auth'
const authStore = useAuthStore()
authStore.checkAuthState()

// Global error handler
app.config.errorHandler = (error, instance, info) => {
  console.error('Vue error:', error, info)
  
  // Send to Sentry if available
  if (typeof window !== 'undefined' && window.Sentry) {
    window.Sentry.withScope((scope: any) => {
      scope.setContext('vue', {
        componentName: instance?.$options.name || 'Unknown',
        errorInfo: info
      })
      window.Sentry.captureException(error)
    })
  }
}

// Mount the app
app.mount('#app')
